import { render, staticRenderFns } from "./up-cost.vue?vue&type=template&id=5a4b9204&scoped=true&"
import script from "./up-cost.vue?vue&type=script&lang=js&"
export * from "./up-cost.vue?vue&type=script&lang=js&"
import style0 from "./up-cost.vue?vue&type=style&index=0&id=5a4b9204&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4b9204",
  null
  
)

export default component.exports